import {
  FormDeliveryElection,
  TaxWorkerDetails,
  UpdateTaxWorkerDetails,
} from '@/types/tax'

import { http } from './http'

export const getTaxWorkerDetails = () =>
  http.get<TaxWorkerDetails>('p2/tax_filing/tax_worker_details')

export const updateTaxWorkerDetails = (payload: UpdateTaxWorkerDetails) =>
  http.put('p2/tax_filing/tax_worker_details', payload)

export const updateTaxWorkerDeliveryConsent = (
  form_delivery_election: FormDeliveryElection
) =>
  http.put('p2/tax_filing/tax_worker_details/form_delivery_election', {
    form_delivery_election,
  })
